if (!customElements.get('formthr-protein-stages')) {
  customElements.define('formthr-protein-stages', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.buttons = [...this.querySelectorAll('[data-stage]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.active === button ? this.close() : this.select(button), options);
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.buttons.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          this.buttons[next].focus();
          this.select(this.buttons[next]);
        }, options);
      });
      this.querySelectorAll('.formthr-stages__close').forEach(button => button.addEventListener('click', () => this.close(true), options));
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && this.active) { event.preventDefault(); this.close(true); } }, options);
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, options);
      window.addEventListener('resize', () => { if (this.active) this.position(); }, options);
      this.querySelectorAll('[data-stage-step]').forEach(button => button.addEventListener('click', () => {
        this.stopAuto();
        const index = this.buttons.indexOf(this.active) + Number(button.dataset.stageStep);
        if (!this.buttons[index]) return;
        this.select(this.buttons[index]);
        this.panels[index].querySelector('[data-stage-step]')?.focus({ preventScroll: true });
      }, options));
      this.mobileQuery = window.matchMedia('(max-width: 767px)');
      this.mobileQuery.addEventListener('change', () => {
        if (this.mobileQuery.matches && !this.active) this.select(this.buttons[0]);
        if (this.active) this.position();
      }, options);
      this.close();
      this.autoIndex = 0;
      this.addEventListener('animationend', event => {
        if (event.animationName === 'formthr-age-progress' && this.mobileQuery.matches) this.advanceAuto();
      }, options);
      this.autoStopped = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.addEventListener('pointerdown', () => this.stopAuto(), options);
      this.addEventListener('focusin', () => this.stopAuto(), options);
      this.addEventListener('pointerenter', () => this.stopAuto(), options);
      this.observer = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .5;
        clearTimeout(this.autoTimer);
        this.classList.toggle('is-timeline-paused', !this.inView || document.hidden);
        if (this.inView && !this.autoStopped && !document.hidden && !(this.mobileQuery.matches && this.querySelector('.is-timing'))) this.advanceAuto();
      }, { threshold: [0, .5] });
      this.observer.observe(this.querySelector('.formthr-stages__timeline'));
      document.addEventListener('visibilitychange', () => {
        clearTimeout(this.autoTimer);
        this.classList.toggle('is-timeline-paused', document.hidden || !this.inView);
        if (!document.hidden && this.inView && !this.autoStopped && !(this.mobileQuery.matches && this.querySelector('.is-timing'))) this.advanceAuto();
      }, options);
    }
    stopAuto() { this.autoStopped = true; clearTimeout(this.autoTimer); this.buttons.forEach(button => button.classList.remove('is-timing')); }
    advanceAuto() {
      if (this.autoStopped || !this.inView || this.autoIndex >= this.buttons.length) return;
      this.buttons.forEach(button => button.classList.remove('is-timing'));
      const button = this.buttons[this.autoIndex++];
      this.select(button);
      if (this.mobileQuery.matches) button.classList.add('is-timing');
      else this.autoTimer = setTimeout(() => this.advanceAuto(), 6500);
    }
    disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); clearTimeout(this.autoTimer); }
    close(restoreFocus = false) {
      if (this.mobileQuery?.matches) {
        if (!this.active && this.buttons.length) this.select(this.buttons[0]);
        return;
      }
      if (restoreFocus) this.active?.focus();
      this.active = null;
      this.buttons.forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.panels.forEach(panel => { panel.hidden = true; });
    }
    select(button) {
      this.active = button;
      this.buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      this.panels.forEach(panel => { panel.hidden = panel.dataset.panel !== button.dataset.stage; });
      this.position();
    }
    position() {
      const panel = this.panels.find(item => !item.hidden);
      if (!panel || !this.active) return;
      const chart = this.querySelector('.formthr-stages__chart').getBoundingClientRect();
      const point = this.active.querySelector('.formthr-stages__dot').getBoundingClientRect();
      const x = point.left + point.width / 2 - chart.left;
      const y = point.top + point.height / 2 - chart.top;
      const left = Math.max(12, Math.min(x - panel.offsetWidth / 2, chart.width - panel.offsetWidth - 12));
      const top = y < chart.height / 2 ? y + 28 : y - panel.offsetHeight - 28;
      panel.style.left = `${left}px`;
      panel.style.top = `${Math.max(12, Math.min(top, chart.height - panel.offsetHeight - 12))}px`;
    }
  });
}
